module.exports = __webpack_public_path__ + "static/img/h_28@2x.32b7818d.png";